import React from "react";
import './PopUpSubHeading.css';

const PopUpSubHeading = ({content})=>{
    return(
        <span className="pop-up-sub-heading">{content}</span>
    )
}

export default PopUpSubHeading;